import { getVendorPropName } from './getVendorProp';
import { raf, caf } from './createRAF';
import createStateManager from '../events/createStateManager';

/**
 * @returns {boolean}
 */
function supportAnimation() {
  if (supportAnimation.supported === undefined) {
    var el = document.createElement('div');
    var vendorAnimationName = getVendorPropName(el.style, 'animationName');
    var supported = vendorAnimationName !== undefined;
    supportAnimation.supported = supported;
    if (supported) {
      var vendor = vendorAnimationName.replace(/animationName$/i, '');
      supportAnimation.vendor = vendor;
      supportAnimation.cssVendor = vendor === '' ? '' : '-' + vendor + '-';
      supportAnimation.animationStartEvent = vendor === '' ? 'animationstart' : vendor + 'AnimationStart';
    }
  }

  return supportAnimation.supported;
}

/**
 * @param {boolean} isSupportAnimation
 * @param {object} vendors
 * @returns {boolean}
 */
function injectStyles(isSupportAnimation, vendors) {
  if (injectStyles.injected === undefined) {
    var style = document.createElement('style');
    var head = document.getElementsByTagName('head')[0];
    var keyframes = '';
    var animationRule = '';

    if (isSupportAnimation) {
      var cssVendor = vendors.cssVendor;


      keyframes = '' + ('@' + cssVendor + 'keyframes resizeanim {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}');
      animationRule = cssVendor + 'animation: resizeanim 1ms;';
    }

    var cssText = '' + (keyframes + '\n.resize-triggers {\n  ' + animationRule + '\n  visibility: hidden;\n  opacity: 0;\n  overflow: hidden;\n}\n.resize-triggers,\n.expand-trigger,\n.contract-trigger {\n  position: absolute;\n  z-index: -1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.expand-trigger,\n.contract-trigger {\n  overflow: auto;\n}\n.contract-trigger:before {\n  content: "";\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 200%;\n  height: 200%;\n  overflow: hidden;\n}');
    style.type = 'text/css';

    if (style.styleSheet) {
      style.styleSheet.cssText = cssText;
    } else {
      style.appendChild(document.createTextNode(cssText));
    }

    head.appendChild(style);
    injectStyles.injected = true;
  }

  return injectStyles.injected;
}

/**
 * @param {HTMLElement} element
 * @returns {void}
 */
function resetTriggers(element) {
  var _element$__resizeTrig = element.__resizeTriggers,
      expandTrigger = _element$__resizeTrig.expandTrigger,
      expandChild = _element$__resizeTrig.expandTrigger.firstElementChild,
      contractTrigger = _element$__resizeTrig.contractTrigger;

  contractTrigger.scrollLeft = contractTrigger.scrollWidth;
  contractTrigger.scrollTop = contractTrigger.scrollHeight;
  expandChild.style.width = expandTrigger.offsetWidth + 1 + 'px';
  expandChild.style.height = expandTrigger.offsetHeight + 1 + 'px';
  expandTrigger.scrollLeft = expandTrigger.scrollWidth;
  expandTrigger.scrollTop = expandTrigger.scrollHeight;
}

/**
 * @returns {void}
 */
function scrollListener() {
  var element = this;
  resetTriggers(element);
  if (element.__frameID) {
    caf(element.__frameID);
  }
  element.__frameID = raf(function () {
    var offsetWidth = element.offsetWidth,
        offsetHeight = element.offsetHeight,
        sizeManager = element.__sizeManager;

    var _sizeManager$getState = sizeManager.getState(),
        width = _sizeManager$getState.width,
        height = _sizeManager$getState.height;

    if (offsetWidth !== width || offsetHeight !== height) {
      sizeManager.setState({
        width: offsetWidth,
        height: offsetHeight
      });
    }
  });
}

/**
 * @param {HTMLElement} element
 * @param {function} fn
 * @returns {void}
 */
export function removeResizeEventListener(element, fn) {
  /* eslint-disable no-param-reassign */
  element.removeEventListener('scroll', scrollListener, true);
  if (element.__sizeManager) {
    element.__sizeManager.unsubscribe(fn);
    element.__sizeManager = null;
  }
  if (element.__resizeTriggers) {
    element.removeChild(element.__resizeTriggers);
    element.__resizeTriggers = null;
  }
  /* eslint-enable no-param-reassign */
}

/**
 * @param {HTMLElement} element
 * @param {function} fn
 */
export function addResizeEventListener(element, fn) {
  if (!element.__sizeManager) {
    if (getComputedStyle(element).position === 'static') {
      // eslint-disable-next-line no-param-reassign
      element.style.position = 'relative';
    }
    var isSupportAnimation = supportAnimation();
    var sizeManager = createStateManager({});
    var resizeTriggers = document.createElement('div');
    var expandTrigger = document.createElement('div');
    var contractTrigger = document.createElement('div');

    resizeTriggers.className = 'resize-triggers';
    expandTrigger.className = 'expand-trigger';
    contractTrigger.className = 'contract-trigger';
    expandTrigger.innerHTML = '<div></div>';
    resizeTriggers.appendChild(expandTrigger);
    resizeTriggers.appendChild(contractTrigger);
    injectStyles(isSupportAnimation, supportAnimation);
    element.appendChild(resizeTriggers);
    resizeTriggers.expandTrigger = expandTrigger;
    resizeTriggers.contractTrigger = contractTrigger;
    /* eslint-disable no-param-reassign */
    element.__resizeTriggers = resizeTriggers;
    element.__sizeManager = sizeManager;
    resetTriggers(element);
    /* eslint-enable no-param-reassign */
    if (isSupportAnimation) {
      var animationStartEvent = supportAnimation.animationStartEvent;

      resizeTriggers.addEventListener(animationStartEvent, function (e) {
        if (e.animationName === 'resizeanim') {
          resetTriggers(element);
        }
      });
    }
    element.addEventListener('scroll', scrollListener, true);
  }

  element.__sizeManager.subscribe(fn);

  return function () {
    return removeResizeEventListener(element, fn);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/elementResizeEvent.js
// module id = 788
// module chunks = 0